import type { CertGenParams } from '@yandex-int/k-common';

/** Серт учителя-инноватора */
export const BaseCert = ({ school_name, locality, first_name, middle_name, last_name }: CertGenParams) => {
    return `
        <!DOCTYPE html>
        <html lang="ru">
            <head>
                <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1.0">
                <title>Сертификат Инноватора</title>
                <style>
                    @font-face
                    {
                        font-family: 'Yandex Sans';
                        font-weight: 500;
                        font-style: normal;
                        font-stretch: normal;

                        src: url(https://e7n.s3.yandex.net/static/education/fonts/YSText-Medium-Web.woff2) format('woff2'),
                        url(https://e7n.s3.yandex.net/static/education/fonts/YSText-Medium-Web.woff) format('woff');
                    }

                    @font-face
                    {
                        font-family: 'YS Text';
                        src: url("https://yastatic.net/s3/home/fonts/ys/1/text-bold.woff2") format("woff2"),
                        url("https://yastatic.net/s3/home/fonts/ys/1/text-bold.woff") format("woff");
                        font-weight: bold;
                        font-style: normal;
                    }

                    @font-face
                    {
                        font-family: 'YS Text';
                        src: url("https://yastatic.net/s3/home/fonts/ys/1/text-regular.woff2") format("woff2"),
                        url("https://yastatic.net/s3/home/fonts/ys/1/text-regular.woff") format("woff");
                        font-weight: 400;
                        font-style: normal;
                    }

                    @font-face
                    {
                        font-family: 'WilliamTextPro';
                        font-weight: normal;
                        font-style: normal;
                        font-stretch: normal;

                        src: url(https://e7n.s3.yandex.net/static/education/fonts/WilliamTextPro-Regular.woff2) format('woff2'),
                        url(https://e7n.s3.yandex.net/static/education/fonts/WilliamTextPro-Regular.woff) format('woff');
                    }

                    @page {
                        size: 210mm 297mm;
                        margin: 0;
                    }

                    @page
                    {
                        size: 210mm 297mm;
                        margin: 0;
                    }

                    html
                    {
                        margin: 0;
                        padding: 0;

                        position: relative;
                    }

                    body
                    {
                        margin: 0;

                        color: #201E1E;

                        position: relative;

                        width: 210mm;
                        height: 297mm;

                        background: #ffffff;
                        box-sizing: border-box;
                        overflow: hidden;

                        page-break-after: always;
                        font-family: YS Text;
                    }

                    .certificate__content-image
                    {
                        position: absolute;
                        top: 0;
                        left: 0;
                        height: 100%;
                        width: calc(272mm * 210 / 595);

                        background-image: url(https://e7n.s3.yandex.net/static/certificates/innovator/background.png);
                        background-repeat: no-repeat;
                        background-size: 100% 100%;
                    }

                    .certificate__logo
                    {
                        position: absolute;
                        top: calc(34mm * 210 / 595);
                        left: calc(313mm * 210 / 595);

                        width: calc(168mm * 210 / 595);
                        height: calc(20mm * 210 / 595);

                        background-image: url(https://e7n.s3.yandex.net/static/certificates/innovator/logo.png);
                        background-repeat: no-repeat;
                        background-size: 100% 100%;
                    }

                    .certificate__header
                    {
                        position: absolute;
                        top: calc(99mm * 210 / 595);
                        left: calc(311mm * 210 / 595);

                        font-style: normal;
                        font-weight: bold;
                        font-size: calc(30mm * 210 / 595);
                        line-height: calc(36mm * 210 / 595);
                        text-align: left;

                        text-transform: uppercase;
                    }

                    .certificate__school
                    {
                        position: absolute;
                        top: calc(227mm * 210 / 595);
                        left: calc(311mm * 210 / 595);
                        font-style: normal;
                        font-weight: 400;
                        font-size: calc(10mm * 210 / 595);
                        line-height: calc(15mm * 210 / 595);
                        width: calc(250mm * 210 / 595);
                    }

                    .certificate__description
                    {
                        position: absolute;
                        top: calc(358mm * 210 / 595);
                        left: calc(311mm * 210 / 595);
                        font-weight: 400;
                        font-style: normal;
                        font-size: calc(10mm * 210 / 595);
                        line-height: calc(15mm * 210 / 595);
                    }

                    .certificate__teacher-data
                    {
                        position: absolute;
                        top: calc(557mm * 210 / 595);
                        left: calc(34mm * 210 / 595);
                        font-style: normal;
                        font-weight: bold;
                        font-size: calc(30mm * 210 / 595);
                        line-height: calc(36mm * 210 / 595);
                        text-transform: uppercase;
                    }

                    .certificate__city
                    {
                        position: absolute;
                        bottom: calc(30mm * 210 / 595);
                        left: calc(526mm * 210 / 595);
                        font-style: normal;
                        font-weight: 400;
                        font-size: calc(10mm * 210 / 595);
                        line-height: calc(15mm * 210 / 595);
                        text-align: right;
                    }

                    .certificate__footer-title
                    {
                        position: absolute;
                        bottom: calc(30mm * 210 / 595);
                        left: calc(34mm * 210 / 595);
                        font-style: normal;
                        font-weight: 400;
                        font-size: calc(10mm * 210 / 595);
                        line-height: calc(15mm * 210 / 595);
                    }

                    .certificate__footer-subscription
                    {
                        position: absolute;
                        top: calc(702mm * 210 / 595);
                        left: calc(214mm * 210 / 595);

                        width: calc(117mm * 210 / 595);
                        height: calc(117mm * 210 / 595);

                        background-image: url(https://e7n.s3.yandex.net/static/certificates-images/sign_da.png);
                        background-repeat: no-repeat;
                        background-size: 100% 100%;
                    }
                </style>
            </head>
            <body>
                <div class="certificate__content">
                    <div class="certificate__content-image"></div>
                    <div class="certificate__logo"></div>
                    <div class="certificate__header">
                        Сертификат<br/>
                        учителю-<br/>
                        инноватору
                    </div>
                    <div class="certificate__school">
                        подтверждает, что учитель <br/>
                        ${school_name} ${locality}
                    </div>
                    <div class="certificate__description">
                        <br />
                        <br />
                        активно использует в учебном процессе цифровые<br />
                        технологии Яндекс Учебника: создаёт уроки<br/>
                        на основе материалов сервиса, выдаёт ученикам<br/>
                        задания в электронном виде и отслеживает<br/>
                        результаты учеников.
                    </div>
                    <div class="certificate__teacher-data">
                        <div class="certificate__teacher-name">${first_name}</div>
                        <div class="certificate__teacher-name">${middle_name}</div>
                        <div class="certificate__teacher-name">${last_name}</div>
                    </div>
                    <div class="certificate__city">
                        Москва<br />
                        ${new Date().getFullYear()}
                    </div>
                    <div class="certificate__footer-title">
                        Директор по взаимодействию<br />
                        с органами власти<br />
                        в сфере образования<br />
                        <br />
                        С благодарностью,<br>Д. А. Растворов
                    </div>
                    <div class="certificate__footer-subscription"></div>
                </div>
            </body>
        </html>
    `;
};
